export default "__VITE_ASSET__BK6BXdbN__"